var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(() => (_vm.is_dropdown = false)),expression:"() => (is_dropdown = false)"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }